const LANG = "lang";
const LEGENDS = "legends";
const LEGEND_PREFIX = "legend-";
const LEGEND_ABBR = "legend-abbr";

/**
 * Ziskani parametru pro preklad u mesage formatu.
 */
function getParams(args) {
	const param = {};

	if (args.length) {
		if (typeof args[0] === "object") {
			// jeden arg. typu object, predame dal
			return args[0];
		} else if (typeof args[0] === "string") {
			// 1..n parametru typu string
			for (let index = 0; index < args.length; index++) {
				param[`S${index + 1}`] = args[index];
			}
		}
	}

	return param;
}

/**
	 * Z dat message formatu vytvori jazyky pro aplikaci.
	 * Seznam jazyku: { lang: hlavni preklady, legends: { preklady pro legendy }}
	 */
function prepareData() {
	if (!("i18nData" in window)) {
		throw new Error("Missing language!");
	}

	const data = window.i18nData;
	const dicts = Object.keys(data);
	const langObj = {
		lang: {},
		legends: {},
	};

	dicts.forEach(dict => {
		const key = dict.split(".")[0];
		const rest = dict.replace(`${key}.`, "");

		if (key.indexOf(LEGEND_PREFIX) === -1) {
			// lang
			langObj[key][rest] = data[dict];
		} else {
			// legends
			if (!(key in langObj[LEGENDS])) {
				langObj[LEGENDS][key] = {};
			}

			langObj[LEGENDS][key][rest] = data[dict];
		}
	});

	return langObj;
}

class I18n {
	_data: {
		lang: object;
		legends: object;
	};

	constructor() {
		this._data = prepareData();
	}

	/**
	 * Ziskani objektu s daty
	 */
	_getData() {
		return this._data || {};
	}

	/**
	 * gettext pro sosani stringu z JSON slovniku
	 * kromě klíče do slovníku je možné zadat libovolný další počet argumentů,
	 * které nahradí postupně všechny výskyty řetězce '%s' v překladu.
	 *
	 * mapy.x.y -> lang[x.y]
	 * x.y -> lang[x.y]
	 * legend-base:x.y -> legends[legend-base][x.y]
	 */
	translate(keyInput: string, ...rest) {
		let key = (keyInput || "").replace(/^mapy\./u, "");

		let langData = {};
		const legendMatch = key.match(/[a-zA-Z-0-9_]+:/u);

		if (legendMatch) {
			const legendKey = legendMatch[0].replace(":", "");

			langData = this._getData()[LEGENDS][legendKey];

			// odstranime
			key = key.replace(legendMatch[0], "");
		} else {
			langData = this._getData()[LANG];
		}

		if (langData && key in langData) {
			key = langData[key](getParams(rest));
		}

		return key;
	}

	/**
	 * Ziskani objektu se vsema legendama pro akt. vybrany jazyk.
	 *
	 * @param {boolean} withoutAbbr Bez zkratek?
	 */
	getLegends(withoutAbbr: boolean) {
		let legends = this._getData()[LEGENDS];

		// preskocime zkratky
		if (withoutAbbr) {
			const withoutLegends = {};

			Object.keys(legends).forEach(name => {
				if (name !== LEGEND_ABBR) {
					withoutLegends[name] = legends[name];
				}
			});

			legends = withoutLegends;
		}

		return legends;
	}
}

const i18n = new I18n();

// eslint-disable-next-line id-length
export const _: typeof i18n.translate = i18n.translate.bind(i18n);
